/** What the typed text in a time field will become, or how to type one when it is not a time. */
import { formatTimeOfDay } from './time-of-day';

export function TimeTypedHint({ typed }: { typed: number | null }) {
  const invalid = typed === null;
  return (
    <div
      role="status"
      style={{
        padding: '8px 11px',
        fontSize: 12,
        fontWeight: 700,
        borderBottom: '1px solid var(--nb-border)',
        color: invalid ? 'var(--nb-warn)' : 'var(--nb-primary-2)',
        background: invalid ? 'var(--nb-warn-soft)' : 'var(--nb-primary-soft)',
      }}
    >
      {invalid ? 'Try 9:30 pm, 930p or 21:30' : `Enter for ${formatTimeOfDay(typed)}`}
    </div>
  );
}
